import { useState } from "react";

import { DEFAULT_TRANSITION_DURATION } from "consts";

export interface UsePageLoadingTransitionOptions {
  transitionDuration?: number;
}

// Purely visual transition - fades pages out/in with timing delays
// Doesn't wait for data loading because parent components load all footprint data upfront via cropProgressQuery/dairyProgressQuery/farmProgressQuery
export const usePageLoadingTransitions = (options: UsePageLoadingTransitionOptions = {}) => {
  const { transitionDuration = DEFAULT_TRANSITION_DURATION } = options;
  const [isTransitioning, setIsTransitioning] = useState(false);

  const startTransition = async (callback: () => void | Promise<void>) => {
    const startTime = Date.now();
    setIsTransitioning(true);

    try {
      await new Promise((resolve) => {
        setTimeout(resolve, transitionDuration / 2);
      });
      await callback();

      const elapsed = Date.now() - startTime;
      await new Promise((resolve) => {
        setTimeout(resolve, elapsed + transitionDuration / 2);
      });
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error("Page transition error:", error);
    } finally {
      setIsTransitioning(false);
    }
  };

  return { isTransitioning, startTransition };
};
